module.exports = __webpack_public_path__ + "9c05e33aaffaa20ddab980ed6b06cc1e.svg";